import React from "react";
import type { IRamadanRiddleDay } from "@types";
import DabdoobSolidIcon from "@svg/DabdoobSolidIcon";
import FireIcon from "@svg/FireIcon";

interface Props {
    days: IRamadanRiddleDay[];
}

interface DayProps {
    day: IRamadanRiddleDay;
}

const MilestoneDay: React.FC<DayProps> = ({ day }) => {
    const isMissed = day.status === "Failed";
    const isCurrent = day.status === "Current";
    const isLocked = day.status === "Locked";

    const fireProps = isCurrent
        ? { fill: "none", stroke: "#F27D23" }
        : isLocked
        ? { fill: "none", stroke: "#956C4A" }
        : isMissed
        ? { fill: "#F69C89", stroke: "#F69C89" }
        : {};

    return (
        <div className="relative flex h-9 w-9 items-center justify-center">
            <FireIcon className="absolute inset-0 h-full w-full" {...fireProps} />
            <span
                className={`font-normal ${
                    isMissed
                        ? "text-[#A21D35] line-through"
                        : isCurrent
                        ? "text-[#F27D23]"
                        : "text-[#4F2F18]"
                } z-10`}
            >
                {day.day_number}
            </span>
        </div>
    );
};

const RegularDay: React.FC<DayProps> = ({ day }) => {
    const isMissed = day.status === "Failed";
    const isCurrent = day.status === "Current";
    const isLocked = day.status === "Locked";

    const fillColor = isLocked ? "transparent" : isMissed ? "#F69C89" : "#CAA278";

    const borderColor = isLocked ? "none" : isMissed ? "#F69C89" : "#CAA278";

    return (
        <div className="relative flex h-9 w-9 items-center justify-center">
            {isCurrent ? (
                <DabdoobSolidIcon className="absolute inset-0 h-full w-full" />
            ) : (
                <div
                    className="absolute inset-0 rounded-full"
                    style={{ backgroundColor: fillColor, borderColor }}
                />
            )}
            <span
                className={`font-normal ${
                    isMissed
                        ? "text-[#A21D35] line-through"
                        : isCurrent
                        ? "text-white"
                        : "text-[#4F2F18]"
                } z-10`}
            >
                {day.day_number}
            </span>
        </div>
    );
};

const RamadanRiddlesCalendar: React.FC<Props> = ({ days }) => {
    if (!days || days.length === 0) {
        return null;
    }

    return (
        <div className="grid grid-cols-7 gap-2">
            {days.map((day) => {
                return (
                    <div key={day.id} className="text-sm font-bold">
                        {day.is_milestone ? <MilestoneDay day={day} /> : <RegularDay day={day} />}
                    </div>
                );
            })}
        </div>
    );
};

export default RamadanRiddlesCalendar;
